const storefrontAccessToken = '9602c0500507d8343bd22f1184b59240';
const storeDomain = '5617f9.myshopify.com';

document.addEventListener('algolia.hooks.initialize', () => {

     const facetAttr = 'meta.custom.master_item_number';
  const containerId = 'facet-master-item-number';


  // Custom HTML for each facet value
  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchFacetItemTemplate',
    (defaultTemplate, ctx = {}) => {
      const { html, attribute, item, isRefined, refine } = ctx;

      // Keep default for all other facets or when item is not available
      if (attribute !== facetAttr || !item || !item.label) return defaultTemplate;

      return html`
        <li class="facet-item customFacetItem ${isRefined ? 'is-active' : ''}">
          <button class="facet-btn"
                  aria-pressed="${isRefined}"
                  onclick="${() => refine(item.value)}">
            <span class="label">${item.label}</span>
            <span class="count">${item.count}</span>
          </button>
        </li>
      `;
    }
  );
  // optional behavior tweaks for this facet
  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', (opts) => {
    opts.refinementList = {
      ...(opts.refinementList || {}),
      [facetAttr]: { operator: 'or', limit: 12, showMore: true }
    };
    return opts;
  });

  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchProductTemplate',
    (_default, hit, html, components) => {
      const img = algoliaShopify.helpers.renderImage(hit, 600);
      const rawColors = hit.meta?.custom?.product_color || '';
      const baseColors = rawColors.split(',').map(t => t.trim()).filter(Boolean);

      let swatchGIDs = [];
      try {
        const rawSwatches = hit.meta?.custom?.product_swatches || '[]';
        const parsed = JSON.parse(rawSwatches);
        if (Array.isArray(parsed)) {
          swatchGIDs = parsed.flatMap(item =>
            typeof item === 'string' && item.includes(',')
              ? item.split(',').map(g => g.trim())
              : [item]
          ).filter(Boolean);
          swatchGIDs = swatchGIDs.slice(0, 50); // just the first one
        }
      } catch (err) {
        console.warn('Invalid swatches format:', err);
      }

      const placeholderId = `swatches-${hit.objectID}`;

      // 1. Render basic product card with placeholder swatches container
     let card; // declare outside so it's available after if/else

if (typeof window.customerId !== 'undefined') {
      let current_prod_newTag = "false";
      let current_prod_newStyle = "false";

      for (const tag of hit.tags) {
        if (tag === 'New Style') {
          current_prod_newTag = "true";
          break; // Stop early once found
        }else if (tag == 'New Color'){
          current_prod_newStyle = "true";
          break;
        }
      }
      

      if(current_prod_newTag == "true"){
        current_prod_newTag = 'showTag'
      }
            if(current_prod_newStyle == "true"){
        current_prod_newStyle = 'NewStyle'
      }

  card = html`

    <div class="ais-hits-item ${current_prod_newTag}">
    <img style="visibility:hidden;" class="productNewColor ${current_prod_newStyle}" loading="lazy" src="//www.nextlevelapparel.com/cdn/shop/t/290/assets/newBox4_medium.png?v=141265637359568003631757302049" alt="New Style Image"/>
      <a href="/products/${hit.handle}">
        <img
          src="${img.src}"
          srcset="${img.srcset}"
          sizes="350px"
          alt="${hit.title}"
        />
        <br/>
        <label class="product_sku" style="min-height:26px">
          ${hit.meta?.custom?.master_item_number || ''}
        </label>
        <br/>
        <span class="product-card__title">
          <a href="/products/${hit.handle}" class="bold" data-instant="">${hit.title}</a>
        </span>
        <price-list class="price-list">
          <sale-price class="text-subdued">
            <span class="sr-only">Sale price</span>From $${parseFloat(hit.price).toFixed(2)}
          </sale-price>
        </price-list>
        <p></p>
      </a>
      <div class="ais-swatch-wrapper" id="${placeholderId}"></div>
    </div>
  `;
} else {
     let current_prod_newTag = "false";
      let current_prod_newStyle = "false";

      for (const tag of hit.tags) {
        if (tag === 'New Style') {
          current_prod_newTag = "true";
          break; // Stop early once found
        }else if (tag == 'New Color'){
          current_prod_newStyle = "true";
          break;
        }
      }
      

      if(current_prod_newTag == "true"){
        current_prod_newTag = 'showTag'
      }
            if(current_prod_newStyle == "true"){
        current_prod_newStyle = 'NewStyle'
      }

  card = html`

    <div class="ais-hits-item ${current_prod_newTag}">
    <img style="visibility:hidden;" class="productNewColor ${current_prod_newStyle}" loading="lazy" src="//www.nextlevelapparel.com/cdn/shop/t/290/assets/newBox4_medium.png?v=141265637359568003631757302049" alt="New Style Image"/>
      <a href="/products/${hit.handle}">
        <img
          src="${img.src}"
          srcset="${img.srcset}"
          sizes="350px"
          alt="${hit.title}"
        />
        <br/>
        <label class="product_sku" style="min-height:26px">
          ${hit.meta?.custom?.master_item_number || ''}
        </label>
        <br/>
        <span class="product-card__title">
          <a href="/products/${hit.handle}" class="bold" data-instant="">${hit.title}</a>
        </span>
        <p></p>
      </a>
      <div class="ais-swatch-wrapper" id="${placeholderId}"></div>
    </div>
  `;
}


      // 2. Now fire async and inject into placeholder
      (async () => {
        if (!swatchGIDs.length) return;
        console.log('Fetching swatch colors...');

        const query = `
          query getProductColors($ids: [ID!]!) {
            nodes(ids: $ids) {
              ... on Product {
                id
                handle
                tags
                featuredImage {
                url
              altText
              }
                metafield(namespace: "custom", key: "product_color") {
                  value
                }
              }
            }
          }
        `;

        try {
          const response = await fetch(`https://${storeDomain}/api/2023-10/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            },
            body: JSON.stringify({ query, variables: { ids: swatchGIDs } }),
          });

          const result = await response.json();
          console.log(result);
         //alert(JSON.stringify(result));

        // Check for "New Color Style" tag in any of the swatch products
          const matchedProduct = result?.data?.nodes?.find(product =>
            product?.tags?.some(tag =>
              tag.toLowerCase().trim() === 'new color'
            )
          );
          const productNewColorImg = document
            .querySelector(`#${placeholderId}`)
            ?.closest('.ais-hits-item')
            ?.querySelector('.productNewColor');

          if (matchedProduct !== undefined || productNewColorImg?.classList.contains('NewStyle')) {
           // alert(placeholderId);

            if (productNewColorImg) {
              productNewColorImg.src = 'https://www.nextlevelapparel.com/cdn/shop/t/290/assets/newBoxColorR_medium.png?';
              productNewColorImg.alt = 'New Color Style';
              productNewColorImg.style.visibility = 'visible';
            }
          }


       const swatchColors = (result?.data?.nodes || [])
  .filter(n => n?.metafield?.value && n?.handle)
  .map(n => ({
    color: n.metafield.value.trim(),
    handle: n.handle.trim(),
    imageUrl: n.featuredImage?.url || '',
    altText: n.featuredImage?.altText || n.metafield?.value || ''
  }));

// Get list of swatch color names for filtering base colors
const swatchColorNames = new Set(swatchColors.map(s => s.color.toLowerCase()));
const swatchColorHandles = new Map(
  swatchColors.map(s => [s.color.toLowerCase(), s.handle])
);

// Only add baseColors that are not already in swatchColors
const mergedColors = [
  ...swatchColors,
  ...baseColors
    .filter(c => !swatchColorNames.has(c.toLowerCase()))
    .map(c => ({
      color: c,
      handle: swatchColorHandles.get(c.toLowerCase()) || null,
      imageUrl: c,
      altText: c
    }))
].filter(colorObj => colorObj.handle !== null);



const makeUrl = (color) =>
  `https://cdn.shopify.com/s/files/1/0835/9886/8783/files/${color.toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/\//g, '-')
    .replace(/-+/g, '-')
    .replace(/[^a-z0-9-]/g, '')}_40x40.jpg`;

const buttons = mergedColors.map(({ color, handle, imageUrl }, index) => {
  const btn = document.createElement('button');
  btn.className = 'ais-swatch meta_color_swatch_item';
    if (index >= 8) {
    btn.classList.add('hide_swatch_color');
  }
  btn.setAttribute('aria-label', color);
  btn.setAttribute('data-product-handle', handle);
  btn.setAttribute('data-product-image', imageUrl);
  btn.style.backgroundImage = `url('${makeUrl(color)}')`;
  btn.innerHTML = `<span class="sr-only">select ${color} color option</span><span class="meta_color_swatch-option_name" data-color="black">${color}</span>`;
  return btn;
});
          const container = document.getElementById(placeholderId);
          if (container) {
            container.innerHTML = ''; // clear placeholder
            buttons.forEach(b => container.appendChild(b));
              if (buttons.length > 8) {
      const moreCount = buttons.length - 8;
    const moreBtn = document.createElement('button');
    moreBtn.className = 'swatch-more';
    moreBtn.innerHTML = `<span class="more_swatch_color">+${moreCount} More</span>`;

    // Click handler to show hidden swatches
    moreBtn.addEventListener('click', () => {
      container.querySelectorAll('.hide_swatch_color').forEach(el => {
        el.classList.remove('hide_swatch_color');
      });
      moreBtn.remove(); // Remove the +X More button after click
    });

    container.appendChild(moreBtn);
              }
            }
        } catch (err) {
          console.error('GraphQL failed:', err);
        }
      })();

      // 3. Return base HTML immediately (sync)
      return card;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
     
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.renderImage(item, 125).src}"
            srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
            sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
         <span class="master_item_number">${item.meta?.custom?.master_item_number || ''}</span>
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
            <span class="bold">
             <span class="reversed-link"> ${components.Highlight({ hit: item, attribute: "title" })}</span>
               </span>
            </div>
            <div class="aa-itemContentColor">
            <span class="text-subdued">Color: ${item.meta?.custom?.product_color || ''}</span>
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );

    algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    // Change the placeholder text of the autocomplete menu
    options.placeholder = "Search Our Products";
      if (!options.products) options.products = {};

    // 2 Ensure the nested object exists
    if (!options.products.searchParameters) {
      options.products.searchParameters = {};
    }

      /* Merge or create the searchParameters object */
      options.products.searchParameters = {
        ...options.products.searchParameters,
        distinct: 1,                   // turn on de-duplication
        attributeForDistinct: 'meta.custom.master_item_number' // make sure this is set in the index
      };

      return options;
    //   options.products.searchParameters.distinct = 1;
    //   options.products.searchParameters.attributeForDistinct = 'meta.custom.master_item_number';
    // return options;
  });

  $(document).on("click", ".meta_color_swatch_item", function () {
  $(".meta_color_swatch_item").removeClass("active_color");

  var color_img_url = $(this).data("product-image");
  console.log("Selected image URL:", color_img_url);

  $(this).addClass("active_color");

  // This will correctly target the <img> inside the same .ais-Hits-item
  const $hitItem = $(this).closest(".ais-Hits-item");
  const $img = $hitItem.find("img").not(".productNewColor");

  if ($img.length && color_img_url) {
    $img.attr("src", color_img_url);
    // Optional: update srcset if needed
    $img.removeAttr("srcset");
  } else {
    console.warn("Image element not found or URL missing.");
  }
});

moreBtn.addEventListener('click', () => {
  container.querySelectorAll('.hide_swatch_color').forEach(el => {
    el.classList.remove('hide_swatch_color');
  });
  moreBtn.remove(); // optional, if you want to remove the button after expanding
});
});


document.addEventListener('DOMContentLoaded', function () {

(function () {
  // Add the class to any new/existing wrappers, once.
  function initHeaders(root) {
    (root || document).querySelectorAll('.ais-facet-dropdown-wrapper:not([data-opened-init])')
      .forEach(function (wrapper) {
        const header = wrapper.querySelector('.ais-header');
        if (header) {
          header.classList.add('opened-dropdown');
          // mark this wrapper as processed so we don't touch it again
          wrapper.setAttribute('data-opened-init', '1');
        }
      });
  }

  // 1) Run immediately for anything already on the page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHeaders(); });
  } else {
    initHeaders();
  }

  // 2) Observe future DOM changes (Algolia renders after load)
  const mo = new MutationObserver(function (mutations) {
    // Minimal work: only scan added nodes
    mutations.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return; // only element nodes
        if (n.matches?.('.ais-facet-dropdown-wrapper')) {
          initHeaders(n);
        } else {
          // if a subtree was added, look inside it
          const candidate = n.querySelector?.('.ais-facet-dropdown-wrapper');
          if (candidate) initHeaders(n);
        }
      });
    });
  });

  mo.observe(document.body, { childList: true, subtree: true });
})();



  document.addEventListener('click', function (e) {

    // The header label that was clicked
    const header = e.target.closest('.ais-header');
    if (!header) return; // click wasn’t on a header

    // Find the checkbox inside the same facet wrapper
    const checkbox = header.closest('.ais-facet-dropdown-wrapper')
                           ?.querySelector('input[type="checkbox"]');
    if (!checkbox) return;

    // Toggle the class on the header itself
    if (checkbox.checked) {
      header.classList.add('opened-dropdown');
    } else {
      header.classList.remove('opened-dropdown');
    }
  });

});


document.addEventListener('DOMContentLoaded', () => {

if (!document.body.classList.contains('product-template')) return;

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook(
  'beforeRecommendHitTemplate',
  (_defaultTemplate, html, item) => {
    const img = algoliaShopify.helpers.renderImage(item, 600);
    const rawColors = item.meta?.custom?.product_color || '';
    const baseColors = rawColors.split(',').map(t => t.trim()).filter(Boolean);
    let swatchGIDs = [];

    try {
      const rawSwatches = item.meta?.custom?.product_swatches || '[]';
      const parsed = JSON.parse(rawSwatches);

      if (Array.isArray(parsed)) {
        swatchGIDs = parsed.flatMap(item =>
          typeof item === 'string' && item.includes(',')
            ? item.split(',').map(g => g.trim())
            : [item]
        ).filter(Boolean);
        swatchGIDs = swatchGIDs.slice(0, 50); 
      }
    } catch (err) {
      console.warn('Invalid swatches format:', err);
    }

    const placeholderId = `swatches-${item.objectID}`;
     let card;

if (typeof window.customerId !== 'undefined') {
    let current_prod_newTag = "false";
    let current_prod_newStyle = "false";

    for (const tag of item.tags) {
      if (tag === 'New Style') {
        current_prod_newTag = "true";
        break; 
      }else if (tag == 'New Color'){
        current_prod_newStyle = "true";
        break;
      }
    }

    if(current_prod_newTag == "true"){
      current_prod_newTag = 'showTag'
    }
          if(current_prod_newStyle == "true"){
      current_prod_newStyle = 'NewStyle'
    }

card = html`
  <div class="ais-hits-item ${current_prod_newTag}">
  <img style="visibility:hidden;" class="productNewColor ${current_prod_newStyle}" loading="lazy" src="//www.nextlevelapparel.com/cdn/shop/t/290/assets/newBox4_medium.png?v=141265637359568003631757302049" alt="New Style Image"/>
    <a href="/products/${item.handle}">
      <img
        src="${img.src}"
        srcset="${img.srcset}"
        sizes="350px"
        alt="${item.title}"
      />
      <br/>
      <label class="product_sku" style="min-height:26px">
        ${item.meta?.custom?.master_item_number || ''}
      </label>
      <br/>
      <span class="product-card__title">
        <a href="/products/${item.handle}" class="bold" data-instant="">${item.title}</a>
      </span>
      <price-list class="price-list">
        <sale-price class="text-subdued">
          <span class="sr-only">Sale price</span>From $${parseFloat(item.price).toFixed(2)}
        </sale-price>
      </price-list>
      <p></p>
    </a>
    <div class="ais-swatch-wrapper" id="${placeholderId}"></div>
  </div>

`;
} else {
     let current_prod_newTag = "false";
    let current_prod_newStyle = "false";

    for (const tag of item.tags) {
      if (tag === 'New Style') {
        current_prod_newTag = "true";
        break; 
      }else if (tag == 'New Color'){
        current_prod_newStyle = "true";
        break;
      }
    }

    if(current_prod_newTag == "true"){
      current_prod_newTag = 'showTag'
    }
          if(current_prod_newStyle == "true"){
      current_prod_newStyle = 'NewStyle'
    }

card = html`
  <div class="ais-hits-item ${current_prod_newTag}">
  <img style="visibility:hidden;" class="productNewColor ${current_prod_newStyle}" loading="lazy" src="//www.nextlevelapparel.com/cdn/shop/t/290/assets/newBox4_medium.png?v=141265637359568003631757302049" alt="New Style Image"/>
    <a href="/products/${item.handle}">
      <img
        src="${img.src}"
        srcset="${img.srcset}"
        sizes="350px"
        alt="${item.title}"
      />
      <br/>
      <label class="product_sku" style="min-height:26px">
        ${item.meta?.custom?.master_item_number || ''}
      </label>
      <br/>
      <span class="product-card__title">
        <a href="/products/${item.handle}" class="bold" data-instant="">${item.title}</a>
      </span>
      <p></p>
    </a>
    <div class="ais-swatch-wrapper" id="${placeholderId}"></div>
  </div>

`;
}
    // 2. Now fire async and inject into placeholder
    (async () => {
      if (!swatchGIDs.length) return;
      console.log('Fetching swatch colors...');
      const query = `
        query getProductColors($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on Product {
              id
              handle
              tags
              featuredImage {
              url
            altText
            }
              metafield(namespace: "custom", key: "product_color") {
                value
              }
            }
          }
        }
      `;

      try {
        const response = await fetch(`https://${storeDomain}/api/2023-10/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
          },
          body: JSON.stringify({ query, variables: { ids: swatchGIDs } }),
        });
        const result = await response.json();

      // Check for "New Color Style" tag in any of the swatch products
        const matchedProduct = result?.data?.nodes?.find(product =>
          product?.tags?.some(tag =>
            tag.toLowerCase().trim() === 'new color'
          )
        );
        
          const productNewColorImg = document
            .querySelector(`#${placeholderId}`)
            ?.closest('.ais-hits-item')
            ?.querySelector('.productNewColor');

          if (matchedProduct !== undefined || productNewColorImg?.classList.contains('NewStyle')) {

            if (productNewColorImg) {
              productNewColorImg.src = 'https://www.nextlevelapparel.com/cdn/shop/t/290/assets/newBoxColorR_medium.png?';
              productNewColorImg.alt = 'New Color Style';
              productNewColorImg.style.visibility = 'visible';
            }
          }

const swatchColors = (result?.data?.nodes || [])
.filter(n => n?.metafield?.value && n?.handle)
.map(n => ({
  color: n.metafield.value.trim(),
  handle: n.handle.trim(),
  imageUrl: n.featuredImage?.url || '',
  altText: n.featuredImage?.altText || n.metafield?.value || ''
}));

// Get list of swatch color names for filtering base colors
const swatchColorNames = new Set(swatchColors.map(s => s.color.toLowerCase()));
const swatchColorHandles = new Map(
swatchColors.map(s => [s.color.toLowerCase(), s.handle])
);

// Only add baseColors that are not already in swatchColors

const mergedColors = [
...swatchColors,
...baseColors
  .filter(c => !swatchColorNames.has(c.toLowerCase()))
  .map(c => ({
    color: c,
    handle: swatchColorHandles.get(c.toLowerCase()) || null,
    imageUrl: c,
    altText: c
  }))
].filter(colorObj => colorObj.handle !== null);


const makeUrl = (color) =>
`https://cdn.shopify.com/s/files/1/0835/9886/8783/files/${color.toLowerCase()
  .replace(/\s+/g, '-')
  .replace(/\//g, '-')
  .replace(/-+/g, '-')
  .replace(/[^a-z0-9-]/g, '')}_40x40.jpg`;



const buttons = mergedColors.map(({ color, handle, imageUrl }, index) => {
const btn = document.createElement('button');
btn.className = 'ais-swatch meta_color_swatch_item';
  if (index >= 8) {
  btn.classList.add('hide_swatch_color');
}

btn.setAttribute('aria-label', color);
btn.setAttribute('data-product-handle', handle);
btn.setAttribute('data-product-image', imageUrl);
btn.style.backgroundImage = `url('${makeUrl(color)}')`;
btn.innerHTML = `<span class="sr-only">select ${color} color option</span><span class="meta_color_swatch-option_name" data-color="black">${color}</span>`;
return btn;
});

        const container = document.getElementById(placeholderId);
        if (container) {
          container.innerHTML = ''; 
          buttons.forEach(b => container.appendChild(b));
          if (buttons.length > 8) {
          const moreCount = buttons.length - 8;
          const moreBtn = document.createElement('button');
          moreBtn.className = 'swatch-more';
          moreBtn.innerHTML = `<span class="more_swatch_color">+${moreCount} More</span>`;

  // Click handler to show hidden swatches
  moreBtn.addEventListener('click', () => {
    container.querySelectorAll('.hide_swatch_color').forEach(el => {
      el.classList.remove('hide_swatch_color');

    });

    moreBtn.remove(); 
  });
  container.appendChild(moreBtn);
            }
          }
      } catch (err) {
        console.error('GraphQL failed:', err);
      }
    })();

    // 3. Return base HTML immediately (sync)
    return card;
  });



    $(document).on("click", ".meta_color_swatch_item", function () {
    $(".meta_color_swatch_item").removeClass("active_color");
    var color_img_url = $(this).data("product-image");
    console.log("Selected image URL:", color_img_url);
    $(this).addClass("active_color");

    // This will correctly target the <img> inside the same .ais-Hits-item
    const $hitItem = $(this).closest(".uic-HorizontalSlider-item");
    const $img = $hitItem.find("img").not(".productNewColor");

    if ($img.length && color_img_url) {
      $img.attr("src", color_img_url);

      // Optional: update srcset if needed
      $img.removeAttr("srcset");
    } else {
      console.warn("Image element not found or URL missing.");
    }
    });
    })

    const observer = new MutationObserver((mutations, obs) => {
    const recommendSection = document.querySelector('.algolia-recommend-custom');

    if (!recommendSection) return;

    const slider = recommendSection.querySelector('.uic-HorizontalSlider-list');

    if (slider) {
      // Rename the slider class to disable native behavior
      slider.classList.remove('uic-HorizontalSlider-list');
      slider.classList.add('uic-HorizontalSlider-listX');

      // Optional: remove overflow or reset layout if needed
      slider.style.overflow = 'visible';
      slider.style.whiteSpace = 'normal';
      slider.style.display = 'grid'; 

      // Stop observing once done
      obs.disconnect();
    }
    });

    // Watch the body for changes (Algolia injects asynchronously)
    observer.observe(document.body, {
    childList: true,
    subtree: true,
    });

});


